import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, DollarSign, TrendingUp, BarChart3 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const PayrollReportsSummaryCards = ({ summary, formatCurrency }) => {
  const { t } = useTranslation();
  return (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{t('payrollRep.empPaid')}</CardTitle>
        <Users className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{summary.total_employees || 0}</div>
        <p className="text-xs text-muted-foreground">{t('payrollRep.empInPeriod')}</p>
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{t('payrollRep.payrollMass')}</CardTitle>
        <DollarSign className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{formatCurrency(summary.total_gross)}</div>
        <p className="text-xs text-muted-foreground">{t('payrollRep.totalGrossAmount')}</p>
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{t('payrollRep.avgSalary')}</CardTitle>
        <TrendingUp className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {formatCurrency((summary.total_gross || 0) / Math.max(summary.total_employees || 1, 1))}
        </div>
        <p className="text-xs text-muted-foreground">{t('payrollRep.avgGross')}</p>
      </CardContent>
    </Card>

    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{t('payrollRep.deductionRate')}</CardTitle>
        <BarChart3 className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {(((summary.total_deductions || 0) / (summary.total_gross || 1)) * 100).toFixed(1)}%
        </div>
        <p className="text-xs text-muted-foreground">{t('payrollRep.deductionsOverGross')}</p>
      </CardContent>
    </Card>
  </div>
  );
};

export default PayrollReportsSummaryCards;
